import { combineReducers } from 'redux';
import hubReducer from './hub';
import sectionReducer from './section';
import subsectionReducer from './subsection';

const reducers = combineReducers({
  hub: hubReducer,
  section: sectionReducer,
  subsection: subsectionReducer,
});

export default reducers;
